
const apiCalls ={
    "loginUser": "auth/login",
    "logoutUser": "auth/logout",
    "loginChangePassword": "auth/loginChangePassword",
    "MenuList": "menus",
    "Settings": "settings",
    "LocationImagePath": "uploads?uploadWhileCreate=true&uploadPath=location",
    "ProfileImagePath": "uploads?uploadWhileCreate=true&uploadPath=employee",
    "dashboard": "dashboard/counts",
    "Facilityemployee": "facilityemployees",
    "Facilityemployees": "facilityemployees",
    "Facilities": "facilitiess",
    "Facilitiess": "facilitiess",
    "Patients": "patientss",
    "Patientss": "patientss",
    "Orders": "orderss",
    "Orderss": "orderss",
    "Uploads": "bulkuploadStatus",
    "Appointmentss":"appointmentss",
    "appointmentss":"appointmentss",
    "Slotss":"slotss",
    "OpenSlots":"slotss/openSlots"
  }
export default apiCalls;
